(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["h93-range"] && !Shopify.designMode) return;
  try {
    
  function initialiseHeritageRange(root) {
    root.querySelectorAll('.h93-range').forEach(function(section) {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const filters = section.querySelector('.h93-range-filters');
      filters.hidden = false;
      filters.addEventListener('click', function(event) {
        const button = event.target.closest('button[data-category]');
        if (!button) return;
        const category = button.dataset.category;
        filters.querySelectorAll('button').forEach(function(item) { item.setAttribute('aria-pressed', String(item === button)); });
        let count = 0;
        section.querySelectorAll('.h93-range-card').forEach(function(card) { card.hidden = category !== 'all' && card.dataset.category !== category; if (!card.hidden) count += 1; });
        const status = section.querySelector('.h93-range-count');
        status.textContent = count + ' ' + status.dataset.label;
      });
    });
  }
  initialiseHeritageRange(document);
  document.addEventListener('shopify:section:load', function() { initialiseHeritageRange(document); });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["h93-season"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('.h93-view-toggle');
    if (!button) return;
    const article = button.closest('.h93-study');
    const showingFront = button.getAttribute('aria-pressed') !== 'true';
    article.querySelector('.h93-front').hidden = !showingFront;
    article.querySelector('.h93-back').hidden = showingFront;
    const label = showingFront ? button.dataset.backLabel : button.dataset.frontLabel;
    button.setAttribute('aria-pressed', String(showingFront));
    button.setAttribute('aria-label', label + ' — ' + article.querySelector('h3').textContent);
    button.textContent = label + ' ↻';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
